import dashboardRoutes from "./dashboard";
import patientsRoutes from "./patient";
import calendarRoutes from "./calendar";
export default [...dashboardRoutes, ...patientsRoutes, ...calendarRoutes];
